import React from 'react';
import download from '../../../../assets/Cards/download.svg';
import downloadDark from '../../../../assets/Cards/download-dark.svg';
import { useTheme } from '../../../../context/ThemeContext';

const DownloadPolicy = props => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
       <div className={props.class} onClick={()=> {
          window.open(`${process.env.REACT_APP_PDF_URL + props.policy_pdf_path}`, '_blank').focus();
       }}>
            <img src={isDark ? downloadDark : download} alt="" />
            <div className="infoText download">Download policy summary</div>
       </div>
  );
};

export default DownloadPolicy;
